import NotFoundPage from '../components/common/not-found/NotFoundPage';
import { getMainLayout } from '../components/layout/MainLayout';

NotFoundPage.getLayout = getMainLayout();

export default NotFoundPage;
